module.exports = __webpack_public_path__ + "img/cnn.2ace0e62.png";